import { useFrame, useThree } from "react-three-fiber"
import { OrbitControls, useGLTF, Environment } from "@react-three/drei"
import { useEffect, useState, useRef } from "react"
import * as THREE from "three"

function Model({ url, modelScale, modelPos }) {
    const model = useGLTF(url)
    const [scale, setScale] = useState(1)

    useEffect(() => {
        if (model.scene) {
            model.scene.scale.set(1, 1, 1)

            const box = new THREE.Box3().setFromObject(model.scene)
            const size = box.getSize(new THREE.Vector3())

            const maxSize = Math.max(size.x, size.y, size.z)
            const desiredSize = 1

            const scaleFactor = desiredSize / maxSize * 3 * modelScale
            setScale(scaleFactor)
        }
    }, [url, modelScale])

    return (
        <>
            <primitive scale={[scale, scale, scale]} object={model.scene} position={modelPos} />
        </>
    )

}

function BackgroundImage({ imageURL }) {
    const { scene, gl } = useThree()
    const textureLoader = new THREE.TextureLoader()
    const bgTexture = useRef()

    useEffect(() => {
        bgTexture.current = textureLoader.load(imageURL, (texture) => {
            texture.colorSpace = THREE.SRGBColorSpace
            texture.wrapS = texture.wrapT = THREE.RepeatWrapping
            scene.background = texture
        })
    }, [imageURL, scene])

    useFrame(() => {
        if (bgTexture.current) {
            const canvasAspect = gl.domElement.clientWidth / gl.domElement.clientHeight;
            const imageAspect = bgTexture.current.image
                ? bgTexture.current.image.width / bgTexture.current.image.height
                : 1
            const aspect = imageAspect / canvasAspect

            bgTexture.current.offset.x = aspect > 1 ? (1 - 1 / aspect) / 2 : 0
            bgTexture.current.repeat.x = aspect > 1 ? 1 / aspect : 1

            bgTexture.current.offset.y = aspect > 1 ? 0 : (1 - aspect) / 2
            bgTexture.current.repeat.y = aspect > 1 ? 1 : aspect
        }
    })

    return null
}

function ModelPage({ url, image, modelScale, modelPosition, cameraPosition }) {
    const [shouldRotate, setShouldRotate] = useState(true)
    const controlsRef = useRef()
    const { camera } = useThree()

    useEffect(() => {
        const controls = controlsRef.current
        camera.position.set(cameraPosition[0], cameraPosition[1], cameraPosition[2])

        if (controls) {
            const handleStart = () => {
                setShouldRotate(false) // 회전 멈추기
            }

            const handleEnd = () => {
                setShouldRotate(true); // 회전 재개
            }

            controls.addEventListener('start', handleStart)
            controls.addEventListener('end', handleEnd)

            return () => {
                controls.removeEventListener('start', handleStart)
                controls.removeEventListener('end', handleEnd)
            }
        }
    }, [controlsRef])

    return (
        <>
            <OrbitControls
                ref={controlsRef}
                // minPolarAngle={Math.PI / 2}
                // maxPolarAngle={Math.PI / 2}
                minAzimuthAngle={-Math.PI / 2}
                maxAzimuthAngle={Math.PI / 2} />
            <Environment preset="sunset" />
            <BackgroundImage imageURL={`./${image}`} />
            <Model url={`/${url}`} modelScale={modelScale} modelPosition={modelPosition} shouldRotate={shouldRotate} />
        </>
    )
}

export default ModelPage